"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ANALYTICS;
  }
});
Object.defineProperty(exports, "ADD_ONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ADD_ONS;
  }
});
Object.defineProperty(exports, "ADVERTISING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ADVERTISING;
  }
});
Object.defineProperty(exports, "CALENDARS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CALENDARS;
  }
});
Object.defineProperty(exports, "CONTENT_IMPORT_EXPORT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_IMPORT_EXPORT;
  }
});
Object.defineProperty(exports, "ECOMMERCE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ECOMMERCE;
  }
});
Object.defineProperty(exports, "FORMS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FORMS;
  }
});
Object.defineProperty(exports, "FORUMS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FORUMS;
  }
});
Object.defineProperty(exports, "GALLERIES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.GALLERIES;
  }
});
Object.defineProperty(exports, "MEDIA", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MEDIA;
  }
});
Object.defineProperty(exports, "MEMBERSHIP", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MEMBERSHIP;
  }
});
Object.defineProperty(exports, "NEWSLETTERS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.NEWSLETTERS;
  }
});
Object.defineProperty(exports, "SEO", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEO;
  }
});
Object.defineProperty(exports, "SOCIAL_NETWORKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_NETWORKING;
  }
});
Object.defineProperty(exports, "UTILITIES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.UTILITIES;
  }
});
Object.defineProperty(exports, "WIDGETS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WIDGETS;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Wordpress.js
// module id = 588
// module chunks = 209 210 211 212 213